var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fragment"},[(_vm.loadedProformOptions > -1 && _vm.orderLoading)?_c('OrdersFBMShowSection',{attrs:{"FBM":_vm.FBM},on:{"addProformProduct":_vm.addProformProduct,"removeProformProduct":_vm.removeProformProduct,"prepareSaveFBM":_vm.prepareSaveFBM,"changeUser":_vm.changeUser}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }